import React, { Component } from "react";
import { connect } from "react-redux";

import { Translate, I18n } from "react-redux-i18n";

import Modal from "react-bootstrap/Modal";

import AddUsers from "./AddUsers";
import UserCard from "../../utils/components/UserCard";
import { compressImage } from "../../utils/Utils";

import "../../../styles/components/evs/modals/EditGroup.scss";
import friends from "../../../styles/images/friends.svg";
import camera from "../../../styles/images/camera.svg";
import plus from "../../../styles/images/plus.svg";

class EditGroup extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      group: this.props.group || {
        imageContent: friends,
        name: "",
        listOfDrivers: [],
      },

      modals: {
        add: false,
      },
    };

    this.handlePickPicture = this.handlePickPicture.bind(this);
    this.handlePictureChange = this.handlePictureChange.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleAddUsers = this.handleAddUsers.bind(this);
    this.handleDeleteUser = this.handleDeleteUser.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.group._id !== this.props.group._id)
      this.safeSetState({ group: this.props.group });
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  handlePickPicture(e) {
    document.getElementById("file-picker").click();
  }

  handlePictureChange(e) {
    let file = e.target.files && e.target.files[0];
    compressImage(file).then(picture => {
      this.safeSetState({ group: Object.assign({}, this.state.group, { imageContent: picture }) });
    });
  }

  handleOnChange(e) {
    let group = Object.assign({}, this.state.group);
    group[e.target.name] = e.target.value;
    this.safeSetState({ group });
  }

  handleAddUsers(e, users) {
    let group = Object.assign({}, this.state.group);
    group.listOfDrivers = group.listOfDrivers.concat(
      users.map(u => Object.assign(u, { new: true }))
    );
    this.safeSetState({ group }, () => this.setModal("add", false));
  }

  handleDeleteUser(e, user) {
    let group = Object.assign({}, this.state.group, {
      listOfDrivers: this.state.group.listOfDrivers.filter(u => u._id !== user._id),
    });
    this.safeSetState({ group });
  }

  setModal(modal, bool) {
    let newModals = Object.assign({}, this.state.modals);
    newModals[modal] = bool;
    this.safeSetState({
      modals: newModals,
    });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  renderUserCards() {}

  render() {
    return (
      <>
        <Modal id="editGroup" show={this.props.show} onHide={this.props.onHide} centered>
          <Modal.Header>
            <Modal.Title>
              <Translate value="drivers_editGroup" />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="picture-picker-container">
              <input
                id="file-picker"
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                onChange={this.handlePictureChange}
              />
              <button type="button" className="picture-picker" onClick={this.handlePickPicture}>
                <img id="picture" src={this.state.group.imageContent} alt="avatar" />
                <img src={camera} className="camera" alt="" />
              </button>
            </div>
            <form id="edit-group-form" onSubmit={e => this.props.onSubmit(e, this.state.group)}>
              <div className="form-field">
                <p>
                  <Translate value="drivers_groupName" />
                </p>
                <input
                  type="text"
                  name="name"
                  placeholder={I18n.t("drivers_groupNameExample")}
                  value={this.state.group.name}
                  onChange={this.handleOnChange}
                />
              </div>
              <div className="form-field user-list">
                {this.state.group &&
                  this.state.group.listOfDrivers.map(u => {
                    return u.admin ? (
                      <UserCard
                        key={u._id}
                        className="admin"
                        type="info"
                        name={u.name || ""}
                        avatar={u.imageContent}
                        info={`${u.internationalPrefix} ${u.mobile}`}
                      />
                    ) : (
                      <UserCard
                        key={u._id}
                        type="info"
                        name={u.name || ""}
                        avatar={u.imageContent}
                        info={`${u.internationalPrefix} ${u.mobile}`}
                        onDelete={e => this.handleDeleteUser(e, u)}
                      />
                    );
                  })}
              </div>
              <div className="form-field">
                <button
                  type="button"
                  className="clear"
                  onClick={() => this.setModal("add", true)}
                  disabled={
                    this.props.isAdmin === false &&
                    this.state.group.listOfDrivers.filter(d => !d.admin).length >=
                      this.props.userPackage?.driversInGroupDriversLimit
                  }
                >
                  <img src={plus} alt="" />
                  <Translate value="drivers_addUser" />
                </button>
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <button type="submit" form="edit-group-form">
              <Translate value="drivers_save" />
            </button>
          </Modal.Footer>
        </Modal>

        <AddUsers
          show={this.state.modals.add}
          onHide={() => this.setModal("add", false)}
          onAdd={this.handleAddUsers}
          listOfUsers={this.state.group.listOfDrivers}
        />
      </>
    );
  }
}

const mapStateToProps = state => ({
  userPackage: state.account.accountData.userPackage,
  isAdmin: state.account.isAdmin,
});

export default connect(mapStateToProps, null)(EditGroup);
